<template>
  <div class="searchbar">
    <div class="searchbar-content">
      <i class="ion ion-search-outline searchbar-content__icon" @click="$emit('search')"></i>
      <div class="searchbar-content__input-container">
        <input
          :value="value"
          type="text"
          placeholder="Search..."
          class="searchbar-content__input"
          @input="$emit('input', $event.target.value)"
          @keyup.enter="$emit('search')"
        />
        <button
          v-show="value"
          class="searchbar-content__delete-word"
          @click="clearSearch"
        >
          X
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UsersSearchBar",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  methods: {
    clearSearch() {
      this.$emit("input", "");
      this.$emit("clear");
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/_variables" as *;
@use "@/assets/scss/_mixin" as *;

.searchbar {
  min-width: 280px;
  width: 320px;
  height: 36px;
  padding: 5px 10px;
  border-radius: 15px;
  border: 2px solid #c0c4cc;

  @media (max-width: 800px) {
    width: 100%;
  }

  &:hover .searchbar-content__delete-word {
    visibility: visible;
  }
}

.searchbar-content {
  position: relative;
  display: flex;
  text-align: start;

  &__icon {
    color: $color-border-container;
    height: auto;
    cursor: pointer;
  }

  &__input-container {
    width: 100%;
  }

  &__input {
    width: 100%;
    margin-left: 5px;
    padding-right: 27px;
    background-color: transparent;
    border: none;
    outline: none;
    text-align: left;
    font-family: $font-family-portal;
    @include font-small-standart-text;
    letter-spacing: 0px;
    color: $color-primary-company;
  }

  &__delete-word {
    position: absolute;
    right: 0;
    top: 0;
    border: none;
    background: none;
    color: #5a607f;
    visibility: hidden;
    cursor: pointer;
  }
}
</style>
